// Firebase configuration for Production environment

const firebaseConfig = {
  apiKey: "AIzaSyDJMUc6gG4AQ5X_zy_O_rAfXkLIxVx6f08",
  authDomain: "output-prototype-2.firebaseapp.com",
  databaseURL: "https://output-prototype-2.firebaseio.com",
  projectId: "output-prototype-2",
  storageBucket: "output-prototype-2.appspot.com",
  messagingSenderId: "35195584483",
  appId: "1:35195584483:web:1dab69de52258a0aca6ad6",
};

export default firebaseConfig;
